import React from "react";
import "./Error.scss";

const Err = ({ message }: { message: string }) => {
    return <p className={"error"}>{message}</p>;
};

export default Err;
